import { BehaviorSubject } from 'rxjs';
import { GameServices } from '../../services/game-services';
import { TwentyOneStylesType } from '../../model/twentyone-types';

export class ScoreLabelViewModel {
  public get defaultFontFamily() {
    return this.gameServices.gameThemeService.defaultFontFamily;
  }
  public get labelColor() {
    return this.gameServices.gameThemeService.getHexColor(this.styleType);
  }
  public get currentScore$() {
    return this.currentScore.asObservable();
  }

  private readonly currentScore: BehaviorSubject<{ value: string; instant: boolean }>;

  constructor(
    private gameServices: GameServices,
    private styleType: TwentyOneStylesType,
    value = '',
  ) {
    this.currentScore = new BehaviorSubject<{ value: string; instant: boolean }>({
      value,
      instant: true,
    });
  }

  public setScore(value: string, instant: boolean): void {
    this.currentScore.next({ value, instant });
  }
}
